const navigation = performance.getEntriesByType('navigation')[0]

if (navigation && navigation.type === 'reload' && window.location.search.includes('page=')) {
  window.location.replace(window.location.pathname)
} else {
  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('#main-collection-product-grid')
    const trigger = document.querySelector('.js-infinite-scroll-trigger')

    if (!grid || !trigger) return

    let isLoading = false

    const loadNextProducts = async () => {
      const nextUrl = trigger.dataset.nextUrl

      if (!nextUrl || isLoading) return

      isLoading = true
      trigger.classList.add('is-loading')

      try {
        const response = await fetch(nextUrl)
        const html = await response.text()
        const doc = new DOMParser().parseFromString(html, 'text/html')

        const nextItems = doc.querySelectorAll('#main-collection-product-grid .grid__item')
        const nextTrigger = doc.querySelector('.js-infinite-scroll-trigger')

        nextItems.forEach((item) => {
          grid.appendChild(item)
        })

        const currentPageUrl = new URL(nextUrl, window.location.origin)
        window.history.replaceState({}, '', currentPageUrl.pathname + currentPageUrl.search)

        if (nextTrigger) {
          trigger.dataset.nextUrl = nextTrigger.dataset.nextUrl
        } else {
          trigger.remove()
          window.removeEventListener('scroll', onScroll)
        }
      } catch (error) {
        console.error('Infinite scroll error:', error)
      } finally {
        setTimeout(() => {
          isLoading = false
          trigger.classList.remove('is-loading')
        }, 300)
      }
    }

    const onScroll = () => {
      if (isLoading) return

      const gridBottom = grid.getBoundingClientRect().bottom
      const windowHeight = window.innerHeight

      if (gridBottom <= windowHeight + 300) {
        loadNextProducts()
      }
    }

    window.addEventListener('scroll', onScroll)
  })
}